import React, { useEffect, useState } from "react";
import { BiUpload } from "react-icons/bi";

const FilePickerField = ({
    preloadedFile,
    onFileSelect,
    label = "Select Image",
    placeHolder = "Select Image",
    acceptedFormats = ".jpg,.png,.jpeg,.mp4,.mkv,.gif,.mov,.pdf",
    maxFileSize = 10,
    disabled = false,
    required = false,
}) => {
    const [selectedFile, setSelectedFile] = useState(preloadedFile || null);

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file.name); // Set the file name
            onFileSelect(file); // Send the selected file to the parent component
        }
    };

    useEffect(() => {
        setSelectedFile(preloadedFile);
    }, []);
    
    return (
        <div className="form-control w-full">
            <label
                htmlFor="filePicker"
                className="block text-sm font-medium text-gray-700 mb-1"
            >
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </label>
            <div className={`border border-gray-300 rounded-lg p-3 flex items-center justify-between bg-white shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer relative ${
                disabled ? 'bg-gray-100 cursor-not-allowed' : 'hover:border-gray-400 focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/50'
            }`}>
                <div className="flex items-center gap-2 truncate">
                    <BiUpload className="h-5 w-5 text-gray-500" />
                    <p className="text-sm text-gray-700">
                        {selectedFile ? selectedFile : `${placeHolder} (Up to ${maxFileSize}MB)`}
                    </p>
                </div>
                {!disabled && (
                    <input
                        type="file"
                        className="absolute inset-0 opacity-0 cursor-pointer"
                        accept={acceptedFormats}
                        onChange={handleFileSelect}
                        disabled={disabled}
                    />
                )}
            </div>
        </div>
    );
};

export default FilePickerField;
